import React from 'react'
import { object, string } from 'prop-types'
import { css } from '@emotion/react'
import { SpacingToken } from '@livechat/design-system-react-components'

import RatingTooltip from '@/components/Rating/Tooltip'
import mediaQueries from '@/layout/media-queries'

const starsRateWrapper = css`
  width: 100%;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: var(${SpacingToken.Spacing3});

  ${mediaQueries.smallScreen(-100)} {
    align-items: flex-end;
    padding-top: var(${SpacingToken.Spacing1});
  }

  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`

const rateAppTextCss = css`
  font-weight: bold;
  font-size: 14px;
  margin-top: 0;
  margin-bottom: var(${SpacingToken.Spacing1});
`

const StarsRates = ({ id, developer }) => {
  return (
    <div css={starsRateWrapper}>
      <div>
        <p css={rateAppTextCss}>How would you rate this app?</p>

        <RatingTooltip
          id={id}
          placement="bottom"
          withStars
          developer={developer}
        />
      </div>
    </div>
  )
}

StarsRates.propTypes = {
  id: string,
  developer: object,
}

export default StarsRates
